import { render, staticRenderFns } from "./VDesignChangelog.vue?vue&type=template&id=2cb332c4&"
import script from "./VDesignChangelog.vue?vue&type=script&lang=ts&"
export * from "./VDesignChangelog.vue?vue&type=script&lang=ts&"
import style0 from "./VDesignChangelog.vue?vue&type=style&index=0&id=2cb332c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports